import { callFunction } from "./functions-client";

// Business CRM (LOS Phase 10).
export const CRM_STATUSES = ["new", "contacted", "qualified", "won", "lost"] as const;
export const CRM_TYPES = ["driver_lead", "partner", "vendor", "other"] as const;

export interface Contact {
  id: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  contact_type: string;
  status: string;
  source?: string | null;
  notes?: string | null;
  created_at: string;
  open_tasks?: number;
}

export interface CrmTask {
  id: string;
  title: string;
  due_date: string | null;
  done: boolean;
  contact_id?: string | null;
  contact_name?: string | null;
}

export const listContacts = (status?: string) =>
  callFunction<{ contacts: Contact[] }>(`crm/contacts${status ? `?status=${encodeURIComponent(status)}` : ""}`, { method: "GET" });

export const createContact = (input: { name: string; email?: string; phone?: string; contact_type?: string; source?: string; notes?: string }) =>
  callFunction<{ contact: Contact }>("crm/contact-create", { body: input });

export const updateContact = (input: { id: string; status?: string; notes?: string; name?: string; email?: string; phone?: string }) =>
  callFunction<{ contact: Contact }>("crm/contact-update", { body: input });

export const getContact = (id: string) =>
  callFunction<{ contact: Contact; tasks: CrmTask[] }>(`crm/contact-get?id=${encodeURIComponent(id)}`, { method: "GET" });

export const addTask = (input: { contact_id?: string; title: string; due_date?: string }) =>
  callFunction<{ task: CrmTask }>("crm/task-add", { body: input });

export const listTasks = (openOnly = true) =>
  callFunction<{ tasks: CrmTask[] }>(`crm/tasks${openOnly ? "?open=1" : ""}`, { method: "GET" });

export const setTaskDone = (id: string, done: boolean) =>
  callFunction<{ task: { id: string; done: boolean } }>("crm/task-done", { body: { id, done } });
